// Side-effect module: sets Lit globals on window before any component that reads them via lit-global.ts
import { html, css, render, LitElement } from "lit-element";
import { unsafeHTML } from "lit-html/directives/unsafe-html.js";
import { ref } from 'lit/directives/ref.js';
import { styleMap } from "lit-html/directives/style-map.js";

globalThis.html = html;
globalThis.css = css;
globalThis.render = render;
globalThis.LitElement = LitElement;
globalThis.unsafeHTML = unsafeHTML;
globalThis.litRef = ref;
globalThis.styleMap = styleMap;
